import { ladbrokesHorseracingConfig as horseracingConfig } from '@frontend/oxygen/lm-core';

const HRconfig = horseracingConfig.config;
if (HRconfig) {
    horseracingConfig.config.tabs = horseracingConfig.config.tabs || {};
    horseracingConfig.config.tabs.specials = {
        hidden: true,
        isNotStarted: true,
        typeFlagCodes: 'SP',
        isNotResulted: true,
        externalKeysEvent: false,
        excludeEventsClassIds: '',
    };
}

export const ladbrokesHorseracingConfig = horseracingConfig;
